import { EntityName } from '../hooks/useActivityLogs'

export type Metadata = {
  order_id?: string
  upsell_id?: string
  upsell_group_name?: string
  coupon_code?: string
  rules?: string
  status?: string
  automation_name?: string
  automation_id?: string
  shipping_rate_name?: string
  [key: string]: any
}

export enum DiscountFLowTabs {
  CREATE_PAYMENT_OFFER = 'create-payment-offer',
  EDIT_PAYMENT_OFFER = 'edit-payment-offer',
  CREATE_C2P_DISCOUNT = 'create-c2p-discount',
  EDIT_C2P_DISCOUNT = 'edit-c2p-discount',
  DISCOUNTS = 'Discounts Tab'
}

export enum ParentComponentTypes {
  ORDERS = 'orders',
  ABANDONED_CARTS = 'abandonedCarts',
  ANALYTICS = 'analytics',
  REWARDS = 'rewards',
  CART_ANALYTICS = 'cart_analytics',
  DISCOUNTS = 'Discounts Tab',
  UPSELL = 'Upsell Tab'
}

export type ActivityLogPayloadType = {
  entityName: EntityName
  entityId?: string
  actionName: string
  metadata?: Metadata
}
